// cart

import { storage, storageKey } from '@lib/storage'
import { withClientSide } from './client-side'

export function getCartItem() {
  return withClientSide(() =>
    storage.local.getByKey<string>(storageKey.cartItem)
  )
}

export function getCartItemQuantity() {
  return withClientSide(() =>
    storage.local.getByKey<number>(storageKey.cartItemQuantity)
  )
}

export function setCartItem(val: string) {
  return withClientSide(() =>
    storage.local.setByKey<string>(storageKey.cartItem, val)
  )
}

export function setCartItemQuantity(val: number) {
  return withClientSide(() =>
    storage.local.setByKey<number>(storageKey.cartItemQuantity, val)
  )
}

export function clearCartItem() {
  return withClientSide(() => storage.local.removeByKey(storageKey.cartItem))
}
export function clearCartItemQuantity() {
  return withClientSide(() =>
    storage.local.removeByKey(storageKey.cartItemQuantity)
  )
}

export function getCart() {
  const item = getCartItem()
  const quantity = getCartItemQuantity()

  return {
    item,
    quantity,
  }
}

export function setCart({
  item,
  quantity,
}: { item: string; quantity: number }) {
  setCartItem(item)
  setCartItemQuantity(quantity)
}

export function clearCart() {
  clearCartItem()
  clearCartItemQuantity()
}
